import * as THREE from 'three';

/**
 * Checks if the given object is a THREE.Mesh instance.
 */
export const isMesh = (object: unknown): object is THREE.Mesh => {
  return !!(object && (object as THREE.Mesh).isMesh);
};
